import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider.tsx';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-neutral-400">{t('notfound.body')}</p>
      <Link to="/" className="text-jub-tile hover:underline">
        {t('notfound.back')}
      </Link>
    </div>
  );
}
